const API_URL = "https://api.openai.com/v1/chat/completions";
const MODEL = process.env.REACT_APP_OPENAI_MODEL || "gpt-4o-mini";

const buildPrompt = (details, kind, variation) => {
  const facts = Object.entries(details)
    .filter(([, v]) => v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && !v.length))
    .map(([k, v]) => `- ${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
    .join("\n");

  const ask =
    kind === "title"
      ? `Write 3 attractive property listing titles (max 45 characters each, no emojis, no quotes, no trailing punctuation).
Every title MUST lead with concrete specifics, in this order of priority: property type + purpose (For Sale / For Rent), size (use the most natural unit given: Kanal or Marla, else sq ft), bedrooms, and the location (sub location, then city). Drop the least important part if it does not fit in 45 characters.
Use a different pattern for each title, for example:
1. "10 Marla House for Sale, DHA Phase 6"
2. "5 Bed Luxury Villa in Bahria Town"
3. "1 Kanal Plot for Sale in Gulberg, Lahore"
Add at most one short appeal word (e.g. Spacious, Luxury, Modern, Prime, Furnished) only if supported by the facts. Never produce generic titles like "Beautiful Property" or "Great Investment Opportunity" without location and size.
Return JSON exactly like {"suggestions":["","",""]}.`
      : `Write 3 different property descriptions (70-120 words each, plain text, no markdown, no emojis).
Each must open with a hook sentence naming the property type, size, bedrooms and exact location (sub location, city), then highlight furnishing, status, price/payment terms and the most appealing amenities from the facts, and close with a short call to action.
Tones: 1 professional and informative, 2 warm and lifestyle-focused, 3 concise and investor-focused (value, location demand, rental/resale potential, only if reasonable from the facts).
Return JSON exactly like {"suggestions":["","",""]}.`;

  return `Property details:\n${facts}\n\n${ask}\nOnly use the facts provided; never invent features, prices or numbers. Variation seed: ${variation}.`;
};

export async function generateListingSuggestions(details, kind, variation = 1) {
  const apiKey = process.env.REACT_APP_OPENAI_API_KEY;
  if (!apiKey) throw new Error("OpenAI API key is not configured.");

  const res = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${apiKey}` },
    body: JSON.stringify({
      model: MODEL,
      temperature: 0.9,
      response_format: { type: "json_object" },
      messages: [
        { role: "system", content: "You are an expert real-estate copywriter who writes accurate, appealing property listings." },
        { role: "user", content: buildPrompt(details, kind, variation) },
      ],
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.error?.message || `OpenAI request failed (${res.status})`);
  }

  const data = await res.json();
  const parsed = JSON.parse(data.choices[0].message.content);
  const limit = kind === "title" ? 45 : Infinity;
  const suggestions = (parsed.suggestions || []).slice(0, 3).map((t) => String(t).trim().slice(0, limit));
  if (!suggestions.length) throw new Error("Unexpected response from OpenAI.");
  return suggestions;
}
